import React, { useState, useCallback, useEffect } from "react";
import Dropzone from "react-dropzone";
import Cropper from "react-easy-crop";
import getCroppedImg from "./getCroppedImg";
import { useDispatch, useSelector } from "react-redux";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { BiCloudUpload } from "react-icons/bi";
import "./uploadCropImg.scss";

// import "./uploadCover.scss";

const UploadCropImg = ({ widthCrop, heightCrop }) => {
  const navigate = useNavigate();
  const [imageUrl, setImage] = useState(null);
  const [CrppedImageUrl, setCrppedImage] = useState(null);
  const [hideCropper, setHideCropper] = useState(false);
  const [crop, setCrop] = useState({ x: 0.5, y: 0.5 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const userState = useSelector((state) => state.userReducer);
  const restaurantState = useSelector((state) => state.restaurantReducer);
  const [responseFromSever, setResponseFromSever] = useState("");
  const width = 200; // Replace this with your desired value for number1
  const height = (width * heightCrop) / widthCrop;

  const onDrop = useCallback((acceptedFiles) => {
    setHideCropper(false);
    const file = acceptedFiles[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      console.log("bbbb", reader.result);
      setImage(reader.result);
    };
  }, []);

  const onCropChange = (crop) => {
    setCrop(crop);
  };

  const onZoomChange = (zoom) => {
    setZoom(zoom);
  };

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const onCrop = async (e) => {
    if (!hideCropper) {
      e.stopPropagation();
      const croppedImageUrl = await getCroppedImg(imageUrl, croppedAreaPixels);
      setCrppedImage(croppedImageUrl);
      console.log({ croppedImageUrl });
      if (croppedImageUrl) {
        dispatch({
          type: "ADD_UPLOAD_CROPED_IMG",
          payload: {
            croppedImageUrl: croppedImageUrl,
          },
        });
      }
      console.log(CrppedImageUrl);
      setHideCropper(true);
    }
  };
  const onCancel = () => {
    setHideCropper(true);
  };

  return (
    <div className="upload-cover-container">
      <Dropzone onDrop={onDrop}>
        {({ getRootProps, getInputProps }) => (
          <div className="upload-cover" {...getRootProps()}>
            <input {...getInputProps()} />
            <BiCloudUpload style={{ fontSize: "2rem" }} />
            <br />
            <span style={{ fontWeight: "bold" }}>( Optional )</span> Drag and
            drop image / Click to select
          </div>
        )}
      </Dropzone>
      {imageUrl && !hideCropper && (
        <div className="cropper" id="cropper">
          <Cropper
            image={imageUrl}
            zoom={zoom}
            crop={crop}
            aspect={1}
            onCropChange={onCropChange}
            onZoomChange={onZoomChange}
            onCropComplete={onCropComplete}
            cropSize={{ height: heightCrop, width: widthCrop }}
          />

          {/* 
          <div style={{ zIndex: 5 }} >
            <button onClick={onCrop}>Crop</button>
            <button onClick={onCancel}>Cancel</button>
          </div>
          <div style={{ zIndex: 5 }}>
            <p>Zoom</p>
            <input
              type="range"
              min={1}
              max={3}
              step={0.1}
              value={zoom}
              onInput={(e) => {
                onZoomChange(e.target.value);
              }}
              className="slider"
            ></input>
          </div> */}

          <div style={{ zIndex: 5 }} className="cropper-buttons-slider">
            <div style={{ zIndex: 5 }} className="cropper-slider">
              <p>Zoom </p>

              <input
                type="range"
                min={1}
                max={3}
                step={0.1}
                value={zoom}
                onInput={(e) => {
                  onZoomChange(e.target.value);
                }}
                className="slider"
              ></input>
            </div>
            <div className="cropper-buttons">
              <button onClick={onCrop}>Crop</button>
              <button onClick={onCancel}>Cancel</button>
            </div>
          </div>
        </div>
      )}
      {CrppedImageUrl && (
        <>
          <img
            src={URL.createObjectURL(CrppedImageUrl)}
            alt="restaurant cover"
            style={{ width: `${100}px`, height: `${100}px` }}
          ></img>
        </>
      )}
    </div>
  );
};

export default UploadCropImg;
